<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="slide-fade">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.meta.path == '' || index == levelList.length - 1">{{ item.meta.title }}</span>
        <router-link v-else :to="item.meta.path">{{ item.meta.title }}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created () {
    this.getBreadcrumb()
  },
  data () {
    return {
      levelList: null
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.name)
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    font-size: 14px;
    margin: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
.slide-fade-enter-active {
  transition: all 1s ease;
}
</style>




// WEBPACK FOOTER //
// src/views/controlCenter/layout/components/BreadCrumb.vue